import API from "./API"

const resource = "/notifications";

export const getQaqcFlags = (params) =>
  API.get("/qaqc/flags/", { params })

export const getAlertNotifications = () =>
  API.get(`${resource}/events/`)

export const getTaskNotifications = () =>
  API.get(`${resource}/fetch_action_notifications_web/`)

export const syncUserFirebaseTokens = (payload) =>
  API.post(`${resource}/store_firebase_device_token/`, payload)

export const assignUsersToEvidencing = (payload) =>
  API.post(`${resource}/assign_users_to_confirmations/`, payload);

export const getAllEvidencingActions = (payload) =>
  API.post(`${resource}/get_practice_confirmation_notifications/`, payload);
